import AssetImporter from './AssetImporter'

export default AssetImporter
